export default function SupportRoute() {
	return (
		<div className="w-full min-h-screen overflow-hidden">
			<section className="py-12 sm:py-16 lg:py-24">
				<div className="px-[15px] md:px-[100px] mx-auto">
					{/* Header Section */}
					<div className="text-center">
						<h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-normal text-neutral-800 mb-6 font-['Futura_Hv_BT']">
							Support Center
						</h1>
						<p className="text-lg sm:text-xl md:text-xl lg:text-2xl text-neutral-600 max-w-5xl mx-auto leading-relaxed font-['Futura_Bk_BT']">
							Need help? We're here to assist you with any questions about
							TrueTenant and make your rental experience seamless.
						</p>
					</div>

					{/* Contact Information */}
					<div className="mt-14 mb-14">
						<div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
							<div className="flex flex-col sm:flex-row items-start gap-4 sm:gap-6 p-4 sm:p-6 border-b border-gray-200">
								<div className="flex-shrink-0">
									<div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center">
										<svg
											className="w-6 h-6 text-[#262626]"
											fill="currentColor"
											viewBox="0 0 20 20"
										>
											<path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
											<path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
											<title>Contact Us</title>
										</svg>
									</div>
								</div>
								<div className="flex-1">
									<h3 className="text-xl sm:text-2xl font-['Futura_Md_BT'] text-neutral-800 mb-2">
										Contact Us
									</h3>
									<div className="space-y-3 text-neutral-600 text-sm sm:text-base lg:text-lg font-['Futura_Bk_BT']">
										<div>
											<strong>Email:</strong> support@truetenant.com
										</div>
										<div>
											<strong>Phone:</strong> (555) 123-4567
										</div>
										<div>
											<strong>Hours:</strong> Monday - Friday, 9 AM - 6 PM EST
										</div>
									</div>
								</div>
							</div>

							<div className="flex flex-col sm:flex-row items-start gap-4 sm:gap-6 p-4 sm:p-6 border-b border-gray-200">
								<div className="flex-shrink-0">
									<div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center">
										<svg
											className="w-6 h-6 text-[#262626]"
											fill="currentColor"
											viewBox="0 0 20 20"
										>
											<path
												fillRule="evenodd"
												d="M12.586 4.586a2 2 0 112.828 2.828l-3 3a2 2 0 01-2.828 0 1 1 0 00-1.414 1.414 4 4 0 005.656 0l3-3a4 4 0 00-5.656-5.656l-1.5 1.5a1 1 0 101.414 1.414l1.5-1.5zm-5 5a2 2 0 012.828 0 1 1 0 101.414-1.414 4 4 0 00-5.656 0l-3 3a4 4 0 105.656 5.656l1.5-1.5a1 1 0 10-1.414-1.414l-1.5 1.5a2 2 0 11-2.828-2.828l3-3z"
												clipRule="evenodd"
											/>
											<title>Quick Links</title>
										</svg>
									</div>
								</div>
								<div className="flex-1">
									<h3 className="text-xl sm:text-2xl font-['Futura_Md_BT'] text-neutral-800 mb-2">
										Quick Links
									</h3>
									<ul className="space-y-2 text-neutral-600 text-sm sm:text-base lg:text-lg font-['Futura_Bk_BT']">
										<li>
											<a
												href="/how-it-works"
												className="text-neutral-600 hover:underline"
											>
												How It Works
											</a>
										</li>
										<li>
											<a
												href="/eligible-rentals"
												className="text-neutral-600 hover:underline"
											>
												Browse Rentals
											</a>
										</li>
										<li>
											<a
												href="/landlord"
												className="text-neutral-600 hover:underline"
											>
												For Landlords
											</a>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>

					{/* FAQ Section */}
					<div className="mt-14 mb-14">
						<h2 className="text-2xl sm:text-3xl lg:text-4xl font-normal text-neutral-800 mb-8 font-['Futura_Hv_BT'] text-center">
							Frequently Asked Questions
						</h2>
					</div>

					{/* FAQ Items */}
					<div className="space-y-6 sm:space-y-8">
						{/* FAQ 1 */}
						<div className="flex flex-col sm:flex-row items-start gap-4 sm:gap-6 p-4 sm:p-6 border-b border-gray-200">
							<div className="flex-shrink-0">
								<div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center">
									<svg
										className="w-6 h-6 text-[#262626]"
										fill="currentColor"
										viewBox="0 0 20 20"
									>
										<path
											fillRule="evenodd"
											d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z"
											clipRule="evenodd"
										/>
										<title>How does the verification process work?</title>
									</svg>
								</div>
							</div>
							<div className="flex-1">
								<h3 className="text-xl sm:text-2xl font-['Futura_Md_BT'] text-neutral-800 mb-2">
									How does the verification process work?
								</h3>
								<p className="text-neutral-600 text-sm sm:text-base lg:text-lg font-['Futura_Bk_BT']">
									Our verification process involves uploading your documents
									(ID, proof of income, rental history) which are then reviewed
									and validated by our team. This typically takes 1-2 business
									days.
								</p>
							</div>
						</div>

						{/* FAQ 2 */}
						<div className="flex flex-col sm:flex-row items-start gap-4 sm:gap-6 p-4 sm:p-6 border-b border-gray-200">
							<div className="flex-shrink-0">
								<div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center">
									<svg
										className="w-6 h-6 text-[#262626]"
										fill="currentColor"
										viewBox="0 0 20 20"
									>
										<path
											fillRule="evenodd"
											d="M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zm0 2v8h12V6H4z"
											clipRule="evenodd"
										/>
										<path d="M6 8h8v2H6V8z" />
										<title>What documents do I need to get verified?</title>
									</svg>
								</div>
							</div>
							<div className="flex-1">
								<h3 className="text-xl sm:text-2xl font-['Futura_Md_BT'] text-neutral-800 mb-2">
									What documents do I need to get verified?
								</h3>
								<p className="text-neutral-600 text-sm sm:text-base lg:text-lg font-['Futura_Bk_BT']">
									You'll need a government-issued ID, proof of income (pay
									stubs, W-2, or tax returns), and rental history from your
									previous landlord. A credit report is optional but
									recommended.
								</p>
							</div>
						</div>

						{/* FAQ 3 */}
						<div className="flex flex-col sm:flex-row items-start gap-4 sm:gap-6 p-4 sm:p-6 border-b border-gray-200">
							<div className="flex-shrink-0">
								<div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center">
									<svg
										className="w-6 h-6 text-[#262626]"
										fill="currentColor"
										viewBox="0 0 20 20"
									>
										<path
											fillRule="evenodd"
											d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
											clipRule="evenodd"
										/>
										<title>Question Mark</title>
									</svg>
								</div>
							</div>
							<div className="flex-1">
								<h3 className="text-xl sm:text-2xl font-['Futura_Md_BT'] text-neutral-800 mb-2">
									How long does it take to get approved for a rental?
								</h3>
								<p className="text-neutral-600 text-sm sm:text-base lg:text-lg font-['Futura_Bk_BT']">
									Verified tenants typically get approved within 24-48 hours,
									compared to the standard 3-5 business days for traditional
									applications.
								</p>
							</div>
						</div>

						{/* FAQ 4 */}
						<div className="flex flex-col sm:flex-row items-start gap-4 sm:gap-6 p-4 sm:p-6 border-b border-gray-200">
							<div className="flex-shrink-0">
								<div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center">
									<svg
										className="w-6 h-6 text-[#262626]"
										fill="currentColor"
										viewBox="0 0 20 20"
									>
										<path d="M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 01-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582zM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 01-.567.267z" />
										<path
											fillRule="evenodd"
											d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 10-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 102 0v-.092a4.535 4.535 0 001.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 9.092V7.151c.391.127.68.317.843.504a1 1 0 101.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5z"
											clipRule="evenodd"
										/>
										<title>Is there a fee for using TrueTenant?</title>
									</svg>
								</div>
							</div>
							<div className="flex-1">
								<h3 className="text-xl sm:text-2xl font-['Futura_Md_BT'] text-neutral-800 mb-2">
									Is there a fee for using TrueTenant?
								</h3>
								<p className="text-neutral-600 text-sm sm:text-base lg:text-lg font-['Futura_Bk_BT']">
									There's no fee to create an account or get verified. Some
									landlords may charge application fees, but these are often
									reduced for verified tenants.
								</p>
							</div>
						</div>

						{/* FAQ 5 */}
						<div className="flex flex-col sm:flex-row items-start gap-4 sm:gap-6 p-4 sm:p-6">
							<div className="flex-shrink-0">
								<div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center">
									<svg
										className="w-6 h-6 text-[#262626]"
										fill="currentColor"
										viewBox="0 0 20 20"
									>
										<path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3z" />
										<path d="M6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" />
										<title>Can landlords use TrueTenant?</title>
									</svg>
								</div>
							</div>
							<div className="flex-1">
								<h3 className="text-xl sm:text-2xl font-['Futura_Md_BT'] text-neutral-800 mb-2">
									Can landlords use TrueTenant?
								</h3>
								<p className="text-neutral-600 text-sm sm:text-base lg:text-lg font-['Futura_Bk_BT']">
									Yes! Landlords can list their properties and receive
									applications from pre-verified tenants. This helps streamline
									the rental process and reduce vacancy rates.
								</p>
							</div>
						</div>
					</div>

					{/* Call to Action */}
					<div className="mt-14 text-center">
						<h3 className="text-xl sm:text-2xl font-['Futura_Md_BT'] text-neutral-800 mb-4">
							Still Need Help?
						</h3>
						<p className="text-neutral-600 text-base sm:text-lg lg:text-xl font-['Futura_Bk_BT'] mb-8">
							Can't find what you're looking for? Our support team is ready to
							help.
						</p>
						<a
							href="mailto:support@truetenant.com"
							className="inline-flex items-center justify-center gap-2 h-12 px-8 py-3 rounded-[47.80px] text-lg font-normal font-['Futura_Md_BT'] transition-colors bg-primary hover:bg-primary/90 text-white"
						>
							Contact Support
						</a>
					</div>
				</div>
			</section>
		</div>
	)
}
